import { render, staticRenderFns } from "./ReviewTagsSettingsList.vue?vue&type=template&id=2dbf0db8&scoped=true&"
import script from "./ReviewTagsSettingsList.vue?vue&type=script&lang=js&"
export * from "./ReviewTagsSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTagsSettingsList.vue?vue&type=style&index=0&id=2dbf0db8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf0db8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
